import { ListingRecommendationsSortOption, ListingRecommendationsSortType } from './types';

export const sortParamMap: Record<
  ListingRecommendationsSortType,
  ListingRecommendationsSortOption
> = {
  EXPECTED_BUSINESS_IMPACT_DESC: {
    sortBy: 'EXPECTED_BUSINESS_IMPACT',
    sortingDirection: 'DESC',
  },
  EXPECTED_BUSINESS_IMPACT_ASC: {
    sortBy: 'EXPECTED_BUSINESS_IMPACT',
    sortingDirection: 'ASC',
  },
  NET_REVENUE_SHARE_DESC: {
    sortBy: 'NET_REVENUE_SHARE',
    sortingDirection: 'DESC',
  },
  NET_REVENUE_SHARE_ASC: {
    sortBy: 'NET_REVENUE_SHARE',
    sortingDirection: 'ASC',
  },
  CURRENT_SKU_COUNT_DESC: {
    sortBy: 'CURRENT_SKU_COUNT',
    sortingDirection: 'DESC',
  },
  CURRENT_SKU_COUNT_ASC: {
    sortBy: 'CURRENT_SKU_COUNT',
    sortingDirection: 'ASC',
  },
  GAP_GLOBAL_AVERAGE_DESC: {
    sortBy: 'GAP_GLOBAL_AVERAGE',
    sortingDirection: 'DESC',
  },
  GAP_GLOBAL_AVERAGE_ASC: {
    sortBy: 'GAP_GLOBAL_AVERAGE',
    sortingDirection: 'ASC',
  },
  GAP_BEST_IN_CLASS_DESC: {
    sortBy: 'GAP_BEST_IN_CLASS',
    sortingDirection: 'DESC',
  },
  GAP_BEST_IN_CLASS_ASC: {
    sortBy: 'GAP_BEST_IN_CLASS',
    sortingDirection: 'ASC',
  },
};
